<template>
  <div class="set-sql-container">
    <div class="sql-radio-group flex">
      <div class="title">标签数据类型</div>
      <div class="flex-1">
        <div>
          <el-radio-group @change="getFileds" v-model="fields">
            <el-radio :label="v.value" v-for="(v, i) in radioList" :key="i">{{
              v.name
            }}</el-radio>
          </el-radio-group>
        </div>
        <div class="remark mt10">
          {{ currentRemark }}
        </div>
      </div>
    </div>
    <div class="flex mt20 sql-wrapper">
      <div class="field-list">
        <el-tree
          default-expand-all
          :data="tableStructure"
          :props="defaultProps"
        ></el-tree>
      </div>
      <div class="flex flex-1 sql-write-container">
        <code-edit :value="sql" @input="getCode"></code-edit>
      </div>
    </div>
  </div>
</template>

<script>
import codeEdit from "@/views/portraitLabelMgt/modules/codeEdit";
export default {
  components: {
    codeEdit
  },
  props: {
    sql: {
      type: String,
      default: ""
    },
    resultType: {
      type: String,
      default: "STRING"
    }
  },
  data() {
    return {
      data: [],
      defaultProps: {
        children: "columns",
        label: "label"
      },
      currentRemark: "",
      fields: "STRING",
      tableStructure: [],
      radioList: [
        {
          name: "字符串",
          value: "STRING",
          remark: 'SQL 语句中第三列返回值为字符串，如:"abc"字符串，如:"abc"'
        },
        {
          name: "布尔",
          value: "BOOLEAN",
          remark: 'SQL 语句中第三列返回值为字符串，如:"abc" 1'
        },
        {
          name: "数值",
          value: "NUMBER",
          remark: 'SQL 语句中第三列返回值为字符串，如:"abc"数值'
        },
        {
          name: "时间",
          value: "DATE",
          remark:
            'SQL 语句中第三列返回值为字符串，如:"abc"时间戳，如:1597786534000'
        },
        {
          name: "集合",
          value: "COLLECTION",
          remark:
            'SQL 语句中第三列返回值为字符串，如:"abc"使用"\n"分割的字符串，如:"手机\n电脑\n相机"'
        }
      ]
    };
  },
  created() {
    this.fields = this.resultType;
    this.getFileds();
    this.queryTableStructure();
  },
  watch: {
    resultType(val) {
      this.fields = val;
    }
  },
  mounted() {},
  methods: {
    async queryTableStructure() {
      const { result } = await this.$store.dispatch("queryTableStructure");
      result.forEach(v => {
        v.label = v.tb;
        v.columns.forEach(o => {
          o.label = o.cl;
        });
      });
      this.tableStructure = result;
    },
    getFileds() {
      this.currentRemark = this.radioList.find(
        v => v.value === this.fields
      ).remark;
      this.$emit("getFileds", this.fields);
    },
    getCode(code) {
      this.$emit("getSql", code);
    }
  }
};
</script>

<style scoped lang="scss">
.sql-radio-group {
  .title {
    font-size: 14px;
    margin-right: 20px;
  }
  .remark {
    color: #8492a6;
    font-size: 12px;
    line-height: 18px;
  }
}

.field-list {
  padding: 14px;
  width: 271px;
  border: 1px solid #e9f0f7;
  border-radius: 3px;
  margin-right: 20px;
  height: 100%;
  overflow-y: auto;
}

.sql-write-container {
  padding: 14px;
  width: 271px;
  border: 1px solid #e9f0f7;
  border-radius: 3px;
}

.sql-wrapper {
  height: calc(100vh - 360px);
  .field-list {
    height: 100%;
  }
  .sql-write-container {
    height: 100%;
  }
}
</style>
